<template>
    <div class="all">
        <div class="top">
            <div class="left">
                <img
                    @click="gotopage('/userInfo', -1)"
                    height="40px"
                    src="https://lanxiaoxiao.obs.cn-north-4.myhuaweicloud.com/web/admin/logo/logo_top.svg"
                    alt=""
                />
            </div>
            <div class="right">
                <el-popover :width="200" placement="bottom">
                    <template #reference>{{ user.company_name }}</template>
                    <div class="tan" @click="loginout()">退出登录</div>
                </el-popover>
            </div>
        </div>
        <div class="main">
            <div class="left">
                <!-- <div v-if="tablist"> -->
                <el-menu router class="tab">
                    <el-sub-menu
                        v-for="(item, index) in tablist"
                        :key="index"
                        :index="item.id"
                    >
                        <template #title>
                            <el-icon>
                                <location />
                            </el-icon>
                            <span>{{ item.name }}</span>
                        </template>
                        <el-menu-item
                            v-for="(ite, inde) in item.list"
                            :key="inde"
                            :index="ite.path"
                            >{{ ite.name }}</el-menu-item
                        >
                    </el-sub-menu>
                </el-menu>
                <!-- </div> -->
            </div>
            <div class="right">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import router from "@/router";


onMounted(() => {
    getmenu();
});

// const tablist = JSON.parse(localStorage.getItem('menu'))
const tablist = ref();
const tab_index = ref(-1);
const userInfo = ref();
const gotopage = (page, index) => {
    if (page) {
        router.push(page);
        tab_index.value = index;
    }
};
const getmenu = () => {
    //tablist.value = res.data.list
    userInfo.value = JSON.parse(localStorage.getItem("user"));
    console.log(userInfo.value);
    if (userInfo.value.usertype == "main") {
        tablist.value = [
            {
                id: 1,
                name: "数据中心",
                icon: "",
                type: 1,
                list: [
                  {
                        id: 1,
                        name: "数据中心",
                        description: null,
                        path: "/dataCenter",
                        icon: null,
                        status: 1,
                    },
                ],
            },
            {
                id: 12,
                name: "账号管理",
                icon: "",
                type: 1,
                list: [
                    {
                        id: 3,
                        name: "账户信息",
                        description: null,
                        path: "/userInfo",
                        icon: null,
                        status: 1,
                    },
                    {
                        id: 4,
                        name: "子账号管理",
                        description: null,
                        path: "/userSub",
                        icon: null,
                        status: 1,
                    },
                    // {
                    //     id: 5,
                    //     name: "密钥管理",
                    //     description: null,
                    //     path: "/userApiManagement",
                    //     icon: null,
                    //     status: 1,
                    // }
                ],
            },
            
        ];
    } else {
        tablist.value = [
            {
                id: 11,
                name: "业务操作",
                icon: "",
                type: 1,
                list: [
                    {
                        id: 1,
                        name: "订单提交",
                        description: null,
                        path: "/orderSubMit",
                        icon: null,
                        status: 1,
                    },
                    {
                        id: 2,
                        name: "订单列表",
                        description: null,
                        path: "/orderList",
                        icon: null,
                        status: 1,
                    },
                ],
            },
            {
                id: 12,
                name: "账号管理",
                icon: "",
                type: 1,
                list: [
                    {
                        id: 3,
                        name: "账户信息",
                        description: null,
                        path: "/userInfo",
                        icon: null,
                        status: 1,
                    }
                ],
            },
            {
                id: 13,
                name: "财务管理",
                icon: "",
                type: 1,
                list: [
                    {
                        id: 6,
                        name: "财务管理",
                        description: null,
                        path: "/payManagement",
                        icon: null,
                        status: 1,
                    },
                    {
                        id: 7,
                        name: "充值缴费",
                        description: null,
                        path: "/payBills",
                        icon: null,
                        status: 1,
                    },
                    {
                        id: 8,
                        name: "财务明细",
                        description: null,
                        path: "/payDetails",
                        icon: null,
                        status: 1,
                    },
                ],
            }
        ];
    }
};

const user = JSON.parse(localStorage.getItem("user"));

const loginout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    router.push("login");
};
</script>

<style lang="scss" scoped>
.all {
    width: 100%;
    height: 100vh;
    min-width: 1000px;
    background-color: #fff;

    .top {
        height: 60px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left {
            margin: 0 20px;
            padding-top: 5px;
        }

        .right {
            color: #000;
            margin-right: 50px;
            cursor: pointer;
        }
    }

    .main {
        height: calc(100vh - 60px);
        display: flex;
        justify-content: space-between;

        .left {
            height: calc(100% - 5px);
            width: 17vw;
            min-width: 200px;
            // background-color: #545C64;
            border-radius: 10px;
            margin-left: 5px;
            padding-top: 10px;
            overflow-y: auto;

            /* webkit 内核 */
            ::-webkit-scrollbar {
                display: none;
            }

            /* Firefox */
            scrollbar-width: none;
            -ms-overflow-style: none;

            .tab {
                height: calc(100% - 10px);
                width: calc(15vw - 15px);
                min-width: 199px;
            }
        }

        .right {
            width: 100%;
            height: 100%;
            overflow-y: auto;
        }
    }
}

.tan {
    text-align: center;
    cursor: pointer;
    color: #000;
}

.tan:hover {
    color: #5381ff;
}
</style>
